import { Col } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";

export const DeleteModalStyled = styled.div`
    .btn {
        background-color: #37c896 !important;
        border-color: #37c896 !important;
    }
`;

export const BatchModalMessage = styled(Col)`
    text-align: left;

    h3 {
        font-size: 16px;
        color: ${colors.greyscale.black};
        margin: 0 0 1em;
        font-weight: 600;
    }

    p {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;

        color: ${colors.greyscale.darker_grey};
    }
`;
